import { AlertTriangle, CheckCircle2, CircleDashed, KeyRound, Loader2, MousePointerClick } from 'lucide-react';
import type { ConnectionStatus } from '@/api/types';
import { Badge } from '@/components/ui';

const CONNECTION_STATUS_LABEL: Record<ConnectionStatus, string> = {
  pending: 'Not finished',
  needs_account: 'Choose an account',
  syncing: 'Syncing',
  active: 'Connected',
  error: 'Sync failed',
  reauth_required: 'Reconnect needed',
};

export function ConnectionStatusBadge({ status }: { status: ConnectionStatus }) {
  const label = CONNECTION_STATUS_LABEL[status];
  switch (status) {
    case 'active':
      return (
        <Badge tone="good" icon={<CheckCircle2 className="size-3" aria-hidden />}>
          {label}
        </Badge>
      );
    case 'syncing':
      return (
        <Badge tone="neutral" icon={<Loader2 className="size-3 animate-spin" aria-hidden />}>
          {label}
        </Badge>
      );
    case 'error':
      return (
        <Badge tone="bad" icon={<AlertTriangle className="size-3" aria-hidden />}>
          {label}
        </Badge>
      );
    case 'reauth_required':
      return (
        <Badge tone="bad" icon={<KeyRound className="size-3" aria-hidden />}>
          {label}
        </Badge>
      );
    case 'needs_account':
      return (
        <Badge tone="yellow" icon={<MousePointerClick className="size-3" aria-hidden />}>
          {label}
        </Badge>
      );
    case 'pending':
      return (
        <Badge tone="outline" icon={<CircleDashed className="size-3" aria-hidden />}>
          {label}
        </Badge>
      );
  }
}
